import SideMenu from '@/containers/side-menu/SideMenu.vue';
import AllowPayment from '@/pages/allow-payment/AllowPayment.vue';

export default {
  path: '/allow-payment',
  name: 'Liberar Pagamento',
  components: {
    mainContent: AllowPayment,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'allow-payment',
    },
    breadcrumb: {
      title: 'Liberar Pagamento',
      paths: [{ title: 'Liberar Pagamento' }],
    },
  },
};
